import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceDetectorService, BROWSERS } from 'ngx-device-detector';

@Injectable()
export class NoCacheInterceptor implements HttpInterceptor {
  constructor(private readonly deviceDetectorService: DeviceDetectorService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.deviceDetectorService.browser() === BROWSERS.IE) {
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT'
        }
      });
    }

    return next.handle(request);
  }
}
